import React, { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import ChangePasswordModal from '../ChangePasswordModal';
import { useAuth } from '../../context/AuthContext';
import './MainLayout.css';

const pageTitles: Record<string, string> = {
  '/dashboard': 'Dashboard',
  '/historial': 'Historial de Compras',
  '/estado-cuenta': 'Estado de Cuenta',
  '/configuracion': 'Configuración'
};

const MainLayout: React.FC = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();
  const { user } = useAuth();

  const title = pageTitles[location.pathname] || 'Estados de Cuenta DNA';

  // Verificar si el usuario debe cambiar contraseña
  const mustChangePassword = user?.must_change_password === true;

  return (
    <div className="main-layout">
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      <div className="main-content">
        <Header title={title} onMenuClick={() => setSidebarOpen(true)} />

        <main className="page-content">
          <Outlet />
        </main>
      </div>

      {/* Modal obligatorio de cambio de contraseña */}
      <ChangePasswordModal
        isOpen={mustChangePassword}
        isFirstTime={true}
        onSuccess={() => {
          // El modal se cerrará automáticamente cuando updateUser cambie must_change_password a false
        }}
      />
    </div>
  );
};

export default MainLayout;
